import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { gql } from '../graphql/generated';
import { isCommentOrPublicCommentThread } from '../utils/post/threadUtils';
import commentThreadPath from '../utils/url/commentThreadPath';

const HISTORICAL_COMMENT_THREAD_QUERY = gql(/** @complexity 1 */ `
  query HistoricalCommentThread($threadId: ID!) {
    thread(id: $threadId) {
      id
      ... on ThreadFields {
        resolvedAt
        version
      }
    }
  }
`);

function useLazyHistoricalCommentThreadPath() {
  const [getPathData] = useLazyQuery(HISTORICAL_COMMENT_THREAD_QUERY);

  return useCallback(
    async (postId: string, threadId: string) => {
      const { data } = await getPathData({ variables: { threadId } });
      const thread = data?.thread;

      return thread && isCommentOrPublicCommentThread(thread)
        ? commentThreadPath(
            {
              ...thread,
              version: thread.version,
              resolvedAt: thread.resolvedAt,
              // instead of spreading commentThreadPath on thread, I construct the post object like this
              // so that we don't need to load the post for each thread
              post: { id: postId, title: '' },
            },
            { isHistorical: true },
          )
        : undefined;
    },
    [getPathData],
  );
}

export default useLazyHistoricalCommentThreadPath;
